export default __webpack_public_path__ + "static/media/sync_data_response_icon.fcfeab36.svg";